/**
 * Search form
 */

(() => {

  const runSearch = (query, searchResults, searchInput, url, searchResultsItems) => {
    searchResults.classList.add('is-loading');
    searchResults.classList.add('open');
    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'text/html;charset=UTF-8'
      },
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
      if(json.length) {
        searchResults.classList.add('open');
        searchResultsItems.innerHTML = '';
        for (var i = 0; i < json.length; i++) {
          var a = document.createElement('a');

          var title = document.createElement('span');
          title.textContent = json[i].title;
          title.classList.add('search-link__title');

          var thumbnail = document.createElement('div');
          thumbnail.innerHTML = json[i].thumbnail;
          thumbnail.classList.add('search-link__thumbnail');

          var excerpt = document.createElement('span');
          excerpt.textContent = json[i].excerpt;
          excerpt.classList.add('search-link__excerpt');

          // var post_type = document.createElement('span');
          // post_type.innerHTML = json[i].breadcrumb;
          // post_type.classList.add('search-link__post-type');

          var heading = document.createElement('span');
          heading.classList.add('search-link__heading');
          heading.appendChild(title);

          var meta = document.createElement('span');
          meta.classList.add('search-link__meta');
          meta.appendChild(excerpt);

          var content = document.createElement('div');
          content.classList.add('search-link__content');

          content.appendChild(heading);
          content.appendChild(meta);

          a.appendChild(thumbnail);
          a.appendChild(content);
          a.href = json[i].link;
          a.classList.add('search-link');

          searchResultsItems.appendChild(a);
          arrowKeyNavigation(searchResultsItems, searchInput);
        }
        searchResults.classList.remove('is-loading');
      } else {
        searchResultsItems.innerHTML = '';
        var p = document.createElement('p');
        if (theme_strings_ajax_search) {
          var text = document.createTextNode(theme_strings_ajax_search.search_no_results);
        }
        p.classList.add('ajax-search-form__results__empty');
        p.appendChild(text);
        searchResultsItems.appendChild(p);
        searchResults.classList.add('open');
        searchResults.classList.remove('is-loading');

      }
    });
  }

  const searchForms = document.querySelectorAll('.js-search-form');
  for (var i = 0; i < searchForms.length; i++) {

    var action = searchForms[i].action;
    var searchInput = searchForms[i].querySelector('[type="search"]');
    var searchResults = searchForms[i].querySelector('.js-search-form-results');
    var searchResultsItems = searchForms[i].querySelector('.js-search-form-results-items');
    var searchSubmit = searchForms[i].querySelector('[type="submit"]');
    var coverButton = searchForms[i].querySelector('.js-ajax-search-form-cover');
    if (!searchInput || !searchResults) {
      console.error('Search form: Invalid markup');
      return;
    }

    if (coverButton) {
      coverButton.addEventListener('click', function(e) {
        e.currentTarget.classList.add('is-active');
        var input = e.currentTarget.parentNode.querySelector('[type="search"]');
        if (input) {
          input.focus();
        }
      });
    }

    // add result node as custom attribute
    searchInput.result = searchResults;

    searchForms[i].addEventListener('submit', (e) => {

      e.preventDefault();

      const form = e.currentTarget;
      const action = form.action;
      const searchInput = form.querySelector('[type="search"]');
      const searchResults = form.querySelector('.js-search-form-results');
      const searchResultsItems = form.querySelector('.js-search-form-results-items');

      if (searchInput.getAttribute('name') == 's') {
        let url = action;
        url += '?s=' + searchInput.value;

        url += '&search_type=ajax';

        runSearch(searchInput.value, searchResults, searchInput, url, searchResultsItems);

        if (searchInput.value.length <= 2) {
          searchResults.classList.remove('open');
        }
      }

    });

    var trigger_timer;
    searchInput.addEventListener('keyup', function(event) {
      let searchInput = this;
      let searchResults = this.result;
      let searchSubmit = this.parentNode.querySelector('[type="submit"]');
      let val = searchInput.value;
      clearTimeout(trigger_timer);
      if (!window.x_search_input_value_length) {
        window.x_search_input_value_length = val.length;
      }


      // arrow key down => focus into first search result
      if (event.keyCode == 40) {
        if (searchResults.querySelector('a')) {
          searchResults.querySelector('a').focus();
        }
      } else {
        if (val.length > 2 || (searchInput.name == 'expert-search' &&  val.length == 0)) {
          // only submit if length if is changed
          if (window.x_search_input_value_length !== val.length) {
            trigger_timer = setTimeout(function() {
              searchSubmit.click();
            }, 500);
          }
        } else {
          searchResults.classList.remove('open');
        }
      }

      window.x_search_input_value_length = val.length;

    });

  }



  // hooks for arrow key navigation for search results
  const arrowKeyNavigation = (searchResults, searchInput) => {
    var list = searchResults;
    var first = list.firstChild; // targets the first <a>
    var maininput = searchInput;  // targets the input, which triggers the functions populating the list
    document.onkeydown = function(e) { // listen to keyboard events
      switch (e.keyCode) {
        case 38: // if the UP key is pressed
          if(document.activeElement == first) {
            maininput.focus();
          }
          if (document.activeElement == (maininput)) { break; } // stop the script if the focus is on the input or first element
          else { document.activeElement.previousSibling.focus(); } // select the element before the current, and focus it
          e.preventDefault(); // don't scroll
          break;
        case 40: // if the DOWN key is pressed
          if (document.activeElement == maininput) { first.focus(); } // if the currently focused element is the main input
          else { document.activeElement.nextSibling.focus(); } // target the currently focused element
          e.preventDefault(); // don't scroll
        break;
      }
    }
  }

  // close menu on outside click
  document.body.addEventListener('click', function(e) {
    var is_search_click = false;
    var el = e.target;
    while (el.parentNode && el.parentNode.classList) {
      if (el.classList.contains('js-search-form')) {
        is_search_click = true;
      }
      el = el.parentNode;
    }
    if (!is_search_click) {
      var open_searches = document.querySelectorAll('.js-search-form .open');
      for (var i = 0; i < open_searches.length; i++) {
        open_searches[i].classList.remove('open');
      }
    }
  });

})();
